export class LoginRequestDTO {
  constructor() {
    this.address = null;
    this.signature = null;
    this.pubkey = null;
    this.guild_id = null;
    this.unix_timestamp = null;
  }
}